import { Question, QuestionType } from 'src/shared/types/question';
import { Update } from 'src/shared/types/update';

import useRouteProductId from '../../../hooks/useRouteProductId';
import ApprovalQuestion from './ApprovalQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import SingleChoiceQuestion from './SingleChoiceQuestion';
import TextQuestion from './TextQuestion';

interface QuestionContentProps {
  update: Update;
}

const questionTypes: QuestionType[] = [
  'multiple_choice',
  'single_choice',
  'text',
  'trigger_sourcing', //v1 says this is deprecated but we still have it in the db
  'approval'
];

const questionTypeMap = {
  multiple_choice: MultipleChoiceQuestion,
  single_choice: SingleChoiceQuestion,
  text: TextQuestion,
  trigger_sourcing: TextQuestion, //v1 says this is deprecated but we still have it in the db
  approval: ApprovalQuestion
};

function createQuestionComponent(
  question: Question,
  update: Update,
  productId: string
) {
  if (questionTypes.includes(question.question_type)) {
    const QuestionComponent =
      questionTypeMap[question.question_type as keyof typeof questionTypeMap];

    return (
      <QuestionComponent
        question={question}
        productId={productId}
        productStage={update.product_stage}
        questionId={update.question_id}
        isComplete={update.update_type === 'complete'}
      />
    );
  }

  return null;
}

const QuestionContent: React.FC<QuestionContentProps> = ({ update }) => {
  const routeProductId = useRouteProductId();

  // Question embedded files (images and non-image attachments alike) are
  // already rendered by `ProductUpdateModalContent` above (via `allImages`
  // and `topLevelNonImageFiles`, which are deduplicated across all update
  // sources), so this component only renders the question widget itself to
  // avoid rendering the same attachments twice.
  return (
    <div className="mb-4">
      {createQuestionComponent(
        update.question as Question,
        update,
        routeProductId as string
      )}
    </div>
  );
};

export default QuestionContent;
